import dnd from "./images/dnd-sticker.jpeg";
import bkind1 from "./images/bekind-sticker(1.jpeg";
import bkind2 from "./images/bekind-sticker(2).jpeg";
import bkind3 from "./images/bekind-sticker(3).jpeg";
import sushi from "./images/sushi-sticer.jpeg";
import hhticket from "./images/harry-house-sticker.jpeg";
import bandc from "./images/bandc-sticker.jpg";
import grinch from "./images/grinch-sticker.jpg";
import cola from "./images/cola-sticker.jpg";
import mistletoe from "./images/mistletoe-sticker.jpg";
import hohoho from "./images/hohoho-sticker.jpg";
import car from "./images/car-sticker.jpg";
import svibes from "./images/santa-vibes-sticker.jpg";
import mxmas from "./images/mc-sticker.jpg";

import "./Products.css";

function Stickers() {
  return (
    <section className="products" id="stickers">
      <h2>Stickers</h2>
      <div className="stickers">
        <div className="card">
          <img
            src={grinch}
            className="card-img-top"
            alt="grinch character full body sticker"
          />
          <div className="card-body">
            <h4 className="card-title"> Grinch</h4>
            <p className="card-text">
              {" "}
              Inventory: 14 <br /> <s>$4</s> $1
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
        <div className="card">
          <img
            src={cola}
            className="card-img-top dim"
            alt="coca cola shaped glass bottle with hohoho logo sticker"
          />
          <div className="card-body">
            <h4 className="card-title"> Cola Bottle Sticker</h4>
            <p className="card-text">
              {" "}
              Inventory: 13 <br /> <s>$4</s>$1
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
        <div className="card">
          <img
            src={mistletoe}
            className="card-img-top"
            alt="meet me under the mistletoe written on top of a mistletoe design sticker"
          />
          <div className="card-body">
            <h4 className="card-title"> Mistletoe Sticker</h4>
            <p className="card-text">
              {" "}
              Inventory: 19
              <br /> <s>$4</s> $1
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
        <div className="card">
          <img
            src={hohoho}
            className="card-img-top"
            alt="hohoho written in red sticker"
          />
          <div className="card-body">
            <h4 className="card-title"> HOHOHO Sticker</h4>
            <p className="card-text">
              {" "}
              Inventory: 22 <br /> <s>$4</s> $1
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
        <div className="card">
          <img
            src={car}
            className="card-img-top"
            alt="red car with tree on top sticker"
          />
          <div className="card-body">
            <h4 className="card-title"> Car Sticker</h4>
            <p className="card-text">
              {" "}
              Inventory: 14 <br /> <s>$3.5</s> $0.5
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
        <div className="card">
          <img
            src={svibes}
            className="card-img-top"
            alt="circular santa vibes sticker in red, green, and white"
          />
          <div className="card-body">
            <h4 className="card-title"> Santa Vibes Sticker</h4>
            <p className="card-text">
              {" "}
              Inventory: 12 <br /> <s>$3.5</s> $0.5
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
        <div className="card">
          <img
            src={mxmas}
            className="card-img-top"
            alt="merry christmas written in cursive in red sticker"
          />
          <div className="card-body">
            <h4 className="card-title"> Merry Christmas Sticker</h4>
            <p className="card-text">
              {" "}
              Inventory: 12 <br /> <s>$3.5</s> $0.5
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
        <div className="card">
          <img
            src={bandc}
            className="card-img-top"
            alt="strawberry with bob styled hair with bangs with whipped cream dolop on top sticker"
          />
          <div className="card-body">
            <h4 className="card-title"> Berries and Cream Sticker</h4>
            <p className="card-text">
              {" "}
              Inventory: 15 <br /> <s>$4</s> $0.5
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
        <div className="card">
          <img
            src={dnd}
            className="card-img-top"
            alt="circular sticker in pink with do not disturb written in white"
          />
          <div className="card-body">
            <h4 className="card-title"> "do not disturb" Sticker</h4>
            <p className="card-text">
              {" "}
              Inventory: 10 <br /> <s>$5</s> $1.5
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
        <div className="card">
          <img
            src={bkind1}
            className="card-img-top"
            alt="a golden mirror with a woman wearing a hijab with the words be kind to yourself in cursive sticker"
          />
          <div className="card-body">
            <h4 className="card-title">
              {" "}
              Be Kind Sticker <em>v1</em>
            </h4>
            <p className="card-text">
              {" "}
              Inventory: 3 <br /> <s>$4</s> $1
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
        <div className="card">
          <img
            src={bkind2}
            className="card-img-top"
            alt="a golden mirror with a woman with an afro with the words be kind to yourself in cursive sticker"
          />
          <div className="card-body">
            <h4 className="card-title">
              {" "}
              Be Kind Sticker <em>v2</em>
            </h4>
            <p className="card-text">
              {" "}
              Inventory: 3 <br /> <s>$4</s> $1
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
        <div className="card">
          <img
            src={bkind3}
            className="card-img-top"
            alt="a golden mirror with a woman with the words be kind to yourself in cursive sticker"
          />
          <div className="card-body">
            <h4 className="card-title">
              {" "}
              Be Kind Sticker <em>v3</em>
            </h4>
            <p className="card-text">
              {" "}
              Inventory: 3 <br /> <s>$4</s> $1
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
        <div className="card">
          <img
            src={sushi}
            className="card-img-top"
            alt="casette tape with sushi restaurant written on it sticker"
          />
          <div className="card-body">
            <h4 className="card-title"> Sushi Restaurant Sticker</h4>
            <p className="card-text">
              {" "}
              Inventory: 3 <br /> <s>$8</s> $2
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
        <div className="card">
          <img
            src={hhticket}
            className="card-img-top"
            alt="cinema ticket titled harrys house sticker black "
          />
          <div className="card-body">
            <h4 className="card-title"> Harry's House Sticker</h4>
            <p className="card-text">
              {" "}
              Inventory: 3 <br /> <s>$8</s> $2
            </p>
            <a href="#contact" className="btn btn-dark">
              DM to Purchase
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Stickers;
